import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "balloon-css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faSquare as farSquare, faCheckCircle, faCalendarAlt, faTimesCircle, faClock, faEdit, faTrashAlt, faCheckSquare } from "@fortawesome/free-regular-svg-icons";
import { faArrowAltCircleLeft, faChevronDown, faPlus, faTimes, faUserLock, faBold, faUnderline, faItalic, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCheckCircle, faTrash, faTimes, faPlus, faItalic, faBold, faUnderline, faCheckSquare, faTimesCircle, farSquare, faChevronDown, faCalendarAlt, faArrowAltCircleLeft, faPlus, faClock, faEdit, faTrashAlt, faTimes, faUserLock);
Vue.component("fai", FontAwesomeIcon);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
